export default "https://cdn-static.gokick.com/assets/316c05c5b819a67ca00dcd3ca58b5d19adb19ecb/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";